<div class="consumer-app-component">
  <mat-card appearance="outlined">
    <mat-tab-group [mat-stretch-tabs]="false" mat-align-tabs="start">
      <mat-tab label="APPLICANT"><div *ngTemplateOutlet="applicantTab;"></div></mat-tab>
      <mat-tab label="PARTNER"><div *ngTemplateOutlet="spouseTab"></div></mat-tab>
      <mat-tab label="REFERENCE"><div *ngTemplateOutlet="referenceTab"></div></mat-tab>
    </mat-tab-group>
  </mat-card>
</div>

<ng-template #applicantTab>
  <div class="row separator header flex space-between align-center"
    fxLayout="row"
    fxLayoutGap="10px"
    fxLayoutAlign="space-between center"
    fxLayout.lt-md="column"
    fxLayoutAlign.lt-md="center start">
    @if (applicationStatus && applicationStatus==='Under Review') {
      <div class="col-md-3 under-review">
        <status-box type="under-review"></status-box>
      </div>
    } @else {
      <div></div>
    }
    <div fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="start center"
      fxLayout.lt-md="column"
      fxLayoutAlign.lt-md="center start">
      @if (applicationStatus !== 'Closed' && application.AppInfoSalesforceID) {
        <button mat-flat-button class="inactive ml-2 w-lt-md-100" (click)="onWithdrawApplication()">
          <span class="mdi mdi-arrow-u-left-bottom" matPrefix></span>
          Withdraw Application
        </button>
      }  
      @if (applicationStatus !== 'Closed' && 
          application.AppInfoStageName !== 'Draft' && 
          !application.AppInfoSalesforceID &&
          (user?.AccessLevel ?? '') === 'admin' && 
          !application.SystemCreditStatus
      ) {
        <button mat-flat-button class="inactive ml-2 w-lt-md-100" (click)="sendToDraft()">
          <span class="mdi mdi-arrow-u-left-bottom" matPrefix></span>
          Back To Draft
        </button>
      }
    </div>
  </div>

  <div class="section">
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Application ID</div>
          <div body>{{getBrokerApplicationId(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Salesforce ID</div>
          <div body>{{getAppSalesforceId(application)}}</div>
        </cell>
      </div>

    </div>

    <!-- Introducer / Introducer Contact / Additional Correspondant -->


    <div class="row reduced-row">
      <div class="col-lg-6 col-md-12">
        <cell>
          <div label>Introducer</div>
          <div body>
            <searchable-select 
              [formControl]="brokerControl"
              [items]="brokerCompanies"
              [multi]="false"
              (selectionChange)="onBrokerChange($event)"
              [isEditable]="isAdminUser() && isApplicationStage()"
            />
          </div>
        </cell>
      </div>
      
      <div class="col-lg-6 col-md-12">
        <cell>
          <div label>Contact</div>
          <div body>
            <searchable-select 
              [formControl]="submitterControl"
              [items]="submitterUsers"
              [multi]="false"
              (selectionChange)="onSubmitterChange($event)"
              [isEditable]="isAdminOrSalesUser()"
            />
          </div>
        </cell>
      </div>
    </div>

        <div class="row reduced-row-gap">
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Sales Contact</div>
              <div body>
                <searchable-select
                  [formControl]="salesContactControl"
                  [items]="salesContactUsers"
                  [multi]="false"
                  (selectionChange)="onSalesContactChange($event)"
                  [isEditable]="isAdminUser()">
                </searchable-select>
              </div>
            </cell>
          </div>
        
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Credit Officer</div>
              <div body>
                <searchable-select 
                  [formControl]="creditOfficerControl"
                  [items]="creditOfficerUsers"
                  [multi]="false"
                  (selectionChange)="onCreditOfficerChange($event)"
                  [isEditable]="isAdminOrCredit()"
                />
              </div>
            </cell>
          </div>
        </div>

        <div class="row reduced-row-gap">
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Settlement Officer</div>
              <div body>
                <searchable-select 
                  [formControl]="settlementControl"
                  [items]="settlementUsers"
                  [multi]="false"
                  (selectionChange)="onSettlementOfficerChange($event)"
                  [isEditable]="isAdminOrOperationUser()"
                />
              </div>
            </cell>
          </div>
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>AML Officer</div>
              <div body>
                <searchable-select
                  [formControl]="amlOfficerControl"
                  [items]="amlOfficerUsers"
                  [multi]="false"
                  (selectionChange)="onAmlOfficerChange($event)"
                  [isEditable]="canEditAmlOfficer"
                />
              </div>
            </cell>
          </div>
          @if (application.AdditionalBrokerCorrespondent && AdditionalBrokerCorrespondentUserId) {
              <div class="col-lg-6 col-md-12">
                <cell>
                  <div label>Additional Correspondant Contact</div>
                  <div body>
                    <searchable-select 
                      [formControl]="additionalCorrespondentControl"
                      [items]="additionalCorrespondentUsers"
                      [multi]="false"
                      (selectionChange)="onAdditionalCorrespondentChange($event)"
                      [isEditable]="isAdminUser()"
                    />
                  </div>
                </cell>
              </div>
            }
          </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>

    <div class="row">
      @if (getInterestRate(application)) {
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Interest rate</div>
            <div body>{{getInterestRate(application)}}<span class="mdi mdi-percent"></span></div>
          </cell>
        </div>
      }
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Amount financed</div>
          <div body><span class="mdi mdi-currency-usd"></span>{{getAmountFinance(application) | looseCurrency:'':''}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>LVR</div>
          <div body>{{getLVR(application)}}<span class="mdi mdi-percent"></span></div>
        </cell>
      </div>
    </div>
    <mat-divider [inset]="true"></mat-divider>

  <div class="section">
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>ABN Age</div>
          <div body>{{getAbnAge(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>ABN Age (with continuity)</div>
          <div body>{{getAbnAgeWithContinuity(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>GST Age</div>
          <div body>{{getGstAge(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>GST Age (with continuity)</div>
          <div body>{{getGstAgeWithContinuity(application)}}</div>
        </cell>
      </div>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>

  <div class="section">
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Finance type</div>
          <div body>{{getFinanceType(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Asset category</div>
          <div body>{{getApplicationAssetCategory(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-6 col-md-12">
        <cell>
          <div label>Asset type</div>
          <div body>{{getAssetType(application)}}</div>
        </cell>
      </div>
    </div>
    <mat-divider [inset]="true"></mat-divider>
    <div class="row">
      @if (getAssetMake(application)) {
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Make</div>
            <div body>{{getAssetMake(application)}}</div>
          </cell>
        </div>
      }
      @if (getAssetFamily(application)) {
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Family</div>
            <div body>{{getAssetFamily(application)}}</div>
          </cell>
        </div>
      }
      @if (getAssetVehicle(application)) {
        <div class="col-lg-6 col-md-12">
          <cell>
            <div label>Model</div>
            <div body>{{getAssetVehicle(application)}}</div>
          </cell>
        </div>
        <mat-divider [inset]="true"></mat-divider>
      }
    </div>
    <div class="row">
      @if (getAssetYear(application)) {
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Year</div>
            <div body>{{getAssetYear(application)}}</div>
          </cell>
        </div>
      }
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Asset condition</div>
          <div body>{{getAssetCondition(application)}}</div>
        </cell>
      </div>
      @if (getAssetDescription(application)) {
        <div class="col-lg-6 col-md-12">
          <cell>
            <div label>Description</div>
            <div body>{{getAssetDescription(application)}}</div>
          </cell>
        </div>
      }
    </div>
    <mat-divider [inset]="true"></mat-divider>
    @if (getAssetAvgRetail(application)) {
      <div class="row">
        @if (getAssetAvgRetail(application)) {
          <div class="col-lg-3 col-md-12">
            <cell>
              <div label>Average Retail</div>
              <div body><span class="mdi mdi-currency-usd"></span>{{getAssetAvgRetail(application) | looseCurrency: '':''}}</div>
            </cell>
          </div>
        }
        @if (getAssetGoodRetail(application)) {
          <div class="col-lg-3 col-md-12">
            <cell>
              <div label>Good Retail</div>
              <div body><span class="mdi mdi-currency-usd"></span>{{getAssetGoodRetail(application) | looseCurrency: '':''}}</div>
            </cell>
          </div>
        }
      </div>
      <mat-divider [inset]="true"></mat-divider>
    }
  </div>



  <div class="section">
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Invoice amount</div>
          <div body><span class="mdi mdi-currency-usd"></span>{{getInvoiceAmount(application) | looseCurrency:'':''}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Loan term (in months)</div>
          <div body>{{getLoanTerms(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Repayment Type</div>
          <div body>{{getRepaymentType(application)}}</div>
        </cell>
      </div>
    </div>
    <mat-divider [inset]="true"></mat-divider>
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Balloon Payment(Residual)</div>
          <div body><span class="mdi mdi-currency-usd"></span>{{getBalloonPayment(application) | looseCurrency:'':''}}</div>
        </cell>
      </div>
    </div>
    <mat-divider [inset]="true"></mat-divider>
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Transaction Type </div>
          <div body>{{getTransactionType(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Equifax Score above 600</div>
          <div body>{{getEquifaxScoreAboveThreshold(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Adverse on file</div>
          <div body>{{getAdverseOnFile(application)}}</div>
        </cell>
      </div>
    </div>
    <mat-divider [inset]="true"></mat-divider>
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Property owner</div>
          <div body>{{getPropertyOwner(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Brokerage</div>
          <div body><span class="mdi mdi-currency-usd"></span>
        {{getBrokerageAmount(application) ? getBrokerageAmount(application) : getBrokerage(application) * getLoanAmount(application) / 100 | looseCurrency:'':''}}</div>
      </cell>
    </div>
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Doc Fee financed</div>
        <div body>{{getDocFeeFinanced(application)}}</div>
      </cell>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>
  <div class="row">
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Repayment frequency</div>
        <div body>{{getRepaymentFrequency(application)}}</div>
      </cell>
    </div>
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Deposit</div>
        <div body><span class="mdi mdi-currency-usd"></span>{{getDeposit(application) | looseCurrency:'':''}}</div>
      </cell>
    </div>
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Loan amount</div>
        <div body><span class="mdi mdi-currency-usd"></span>{{getLoanAmount(application) | looseCurrency:'':''}}</div>
      </cell>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>
</div>


<div class="section">
  <div class="row">
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Title</div>
        <div body>{{getApplicantTitle(application)?.name}}</div>
      </cell>
    </div>
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>First name</div>
        <div body class=" ellipsis" matTooltip="{{getApplicantFirstName(application)}}">{{getApplicantFirstName(application)}}</div>
      </cell>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>
  <div class="row">
    @if (getApplicantMiddleName(application)) {
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Middle name</div>
          <div body class=" ellipsis" matTooltip="{{getApplicantMiddleName(application)}}">{{getApplicantMiddleName(application)}}</div>
        </cell>
      </div>
    }
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Last name</div>
        <div body class=" ellipsis" matTooltip="{{getApplicantLastName(application)}}">{{getApplicantLastName(application)}}</div>
      </cell>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>

  @if (getApplicantIdentification(application)) {
  <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Id Type</div>
          <div body class=" ellipsis" matTooltip="{{idTypeValueToLabel(application)}}">{{idTypeValueToLabel(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>{{idNumberLabel}}</div>
          <div body class=" ellipsis" matTooltip="{{getApplicantIdentification(application)?.idNumber}}">{{getApplicantIdentification(application)?.idNumber}}</div>
        </cell>
      </div>
    </div>
  <mat-divider [inset]="true"></mat-divider>
  }

  <div class="row">
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Date of birth</div>
        <div body>{{displayableDate(getApplicantDob(application))}}</div>
      </cell>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>

  <div class="row">
    <div class="col-lg-6 col-md-12">
      <cell>
        <div label>Residential address</div>
        <div body>{{getApplicantResidentialAddress(application)?.address}}</div>
      </cell>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>

  <div class="row">
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Property owner</div>
        <div body>{{booleanToYesNo(getApplicantPropertyOwnerWithAddress(application)?.propertyOwner)}}</div>
      </cell>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>
</div>


<div class="section">
  <div class="row">
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Email address</div>
        <div body class="long-input">{{getApplicantEmail(application)}}</div>
      </cell>
    </div>
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Mobile number</div>
        <div body>{{getApplicantMobile(application)}}</div>
      </cell>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>

  <div class="row">
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Marital status</div>
        <div body>{{getApplicantMaritalStatus(application)?.name}}</div>
      </cell>
    </div>
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Number of dependants</div>
        <div body>{{getApplicantNumberOfDependants(application)}}</div>
      </cell>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>

  <div class="row">
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Employment status</div>
        <div body>{{getApplicantEmploymentStatus(application)?.name}}</div>
      </cell>
    </div>
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Applicant regular income (after tax)</div>
        <div body>{{getApplicantRegularIncome(application)?.income}} / {{getApplicantRegularIncome(application)?.period?.name}}</div>
      </cell>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>


  <div class="row">
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Employer</div>
        <div body class="long-input">{{getApplicantEmployer(application)?.currentEmployer}}</div>
      </cell>
    </div>
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Employer contact</div>
        <div body>{{getApplicantEmployer(application)?.currentEmployerContact}}</div>
      </cell>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>


  <div class="row">
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Time at current employment</div>
        <div body>{{getApplicantEmployer(application)?.yearsAtCurrentEmployer}} years {{getApplicantEmployer(application)?.monthsAtCurrentEmployer}} months</div>
      </cell>
    </div>
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Guarantor</div>
        <div body>{{booleanToYesNo(getApplicantGuarantor(application))}}</div>
      </cell>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>
</div>

</ng-template>

<ng-template #spouseTab>
  <individual-details type="spouse-only" [applicationId]="application.ApplicationId"></individual-details>
</ng-template>

<ng-template #referenceTab>
  <references-details [application]="application"></references-details>
</ng-template>
